import { useEffect, useState } from 'react';
import { useIsOnboarded } from '../../hooks/use-is-onboarded';

import UserFlow from './onboarding-flows/new-user/UserFlow';
import FirmFlowContainer from './onboarding-flows/FirmFlowContainer';
import OnboardingSidebar from './OnboardingSidebar';

function OnboardingForm(): JSX.Element {
    const { isLoading, hasProfile } = useIsOnboarded();
    const [flow, setFlow] = useState<string>();

    useEffect(() => {
        if (isLoading) {
            return;
        }
        if (hasProfile) {
            setFlow('firm');
        } else {
            setFlow('user');
        }
    }, [hasProfile, isLoading]);

    return (
        <div className="grid grid-cols-[1fr_2fr] w-full h-full">
            {isLoading && (
                <>
                    <OnboardingSidebar>
                        <></>
                    </OnboardingSidebar>
                    <div></div>
                </>
            )}
            {!isLoading && flow === 'user' && <UserFlow />}
            {!isLoading && flow === 'firm' && <FirmFlowContainer />}
        </div>
    );
}

export default OnboardingForm;
